__webpack_require__.p = "/quizzical-app/";